var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LogoIcon, LogoTextIcon } from '@core';
export var NotFoundScreen = function () {
    return (_jsx("div", __assign({ className: "flex h-screen w-screen items-center justify-center" }, { children: _jsxs("div", __assign({ className: "flex flex-col gap-[30px]" }, { children: [_jsx("p", __assign({ className: "text-center text-lg text-input-value-black" }, { children: "404 Not found" })), _jsxs("div", __assign({ className: "flex animate-pulse flex-row items-center gap-[12px]" }, { children: [_jsx(LogoIcon, { className: "h-[40px] w-[39px]" }), _jsx(LogoTextIcon, { className: "h-[64px] w-[170px]" })] }))] })) })));
};
